import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyBsbdkNsRh0GogD3WYwPnghCjKCQ-sLVSA",
  authDomain: "todoapp-d4fbc.firebaseapp.com",
  projectId: "todoapp-d4fbc",
  storageBucket: "todoapp-d4fbc.appspot.com",
  messagingSenderId: "391182886151",
  appId: "1:391182886151:web:5e066f2953032313ddd1a2",
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export { db };
